/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './alarms.scss';

/*@ngInject*/
export default function AlarmsController(userService, types/*, adminService, types, toast, $scope, $rootScope, $state, $translate*/) {

    var vm = this; //eslint-disable-line

    vm.$onInit = function () {
        var user = userService.getCurrentUser();
        if (user.authority == types.authority.PROVIDER_ADMIN.value) {
            vm.entityId = {id: user.providerId, entityType: types.entityType.provider};
        } else if (user.authority == types.authority.CUSTOMER_ADMIN.value) {
            vm.entityId = {id: user.customerId, entityType: types.entityType.customer};
        } else if (user.authority == types.authority.CUSTOMER_USER.value) {
            vm.entityId = {id: user.customerId, entityType: types.entityType.customer};
        } else if (user.authority == types.authority.PROVIDER_USER.value) {
            vm.entityId = {id: user.customerId, entityType: types.entityType.customer};
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/alarm/alarms.controller.js